module.exports = __webpack_public_path__ + "img/user04.2ac1f2cc.png";